import { useState } from 'react'
import { toast } from 'react-toastify';

// Assets
import { ReactComponent as IconInfo } from "assets/info-black.svg"

// Components
import Button from 'components/v1/Button';
import ModalEditCalonMa from 'pages/dashboard/training/components/modal-edit-ma';
import ModalSukses from "pages/dashboard/training/components/modal-sukses"
import ModalKonfirmasiNegative from "pages/dashboard/training/components/modal-konfirmasi-negative"
import ModalDaftarTraining from "pages/dashboard/training/components/modal-daftar-training"
import ModalUnggahLampiran from "pages/dashboard/training/components/modal-unggah-lampiran"

// Api
import { useDeleteCalonMa, useRegisterParticipant } from 'api/training/mutation';

// Ctx
import { useTrainingCtx } from "pages/dashboard/training/useTraining"

const CardCalonMa = ({ calonMa }) => {
  const {
    listAllTrainingAndBatches,
    refetchAll,
    isFreeBatchOpen,
    isPaidBatchOpen,
  } = useTrainingCtx()

  const { name_of_ktp, company, id, registration_number } = calonMa || {};

  const { mutate: mutateDeleteCalonMa } = useDeleteCalonMa()
  const { mutate: mutateRegisterParticipant } = useRegisterParticipant()

  const [batchId, setBatchId] = useState(null)

  // Modals
  const [isOpenModalEditCalonMa, setIsOpenModalEditCalonMa] = useState(false)
  const [isOpenModalSuksesEditCalonMa, setIsOpenModalSuksesEditCalonMa] = useState(false)
  const [isOpenModalKonfirmasiHapusCalonMa, setIsOpenModalKonfirmasiHapusCalonMa] = useState(false)
  const [isOpenModalSuksesHapusCalonMa, setIsOpenModalSuksesHapusCalonMa] = useState(false)
  const [isOpenModalRegisterCalonMa, setIsOpenModalRegisterCalonMa] = useState(false)
  const [isModalUnduhLampiran, setIsModalUnduhLampiran] = useState(false)
  const [isUploadLampiran, setUploadLampiran] = useState(false)

  // Modals Handler
  const handleOpenModalEditCalonMa = () => setIsOpenModalEditCalonMa(true)
  const handleCloseModalEditCalonMa = () => setIsOpenModalEditCalonMa(false)

  const handleOpenModalSuksesEditCalonMa = () => setIsOpenModalSuksesEditCalonMa(true)
  const handleCloseModalSuksesEditCalonMa = () => setIsOpenModalSuksesEditCalonMa(false)

  const handleOpenModalKonfirmasiHapusCalonMa = () => setIsOpenModalKonfirmasiHapusCalonMa(true)
  const handleCloseModalKonfirmasiHapusCalonMa = () => setIsOpenModalKonfirmasiHapusCalonMa(false)

  const handleOpenModalSuksesHapusCalonMa = () => setIsOpenModalSuksesHapusCalonMa(true)
  const handleCloseModalSuksesHapusCalonMa = () => setIsOpenModalSuksesHapusCalonMa(false)

  const handleOpenModalRegisterCalonMa = () => setIsOpenModalRegisterCalonMa(true)
  const handleCloseModalRegisterCalonMa = () => setIsOpenModalRegisterCalonMa(false)

  const handleOpenModalUnduhLampiran = () => setIsModalUnduhLampiran(true)
  const handleCloseModalUnduhLampiran = () => setIsModalUnduhLampiran(false)

  const handleDeleteCalonMa = () => {
    mutateDeleteCalonMa(id, {
      onSuccess: () => {
        handleCloseModalKonfirmasiHapusCalonMa()
        handleOpenModalSuksesHapusCalonMa()
        refetchAll()
        toast.success("Berhasil menghapus calon Marketing Associate")
      },
      onError: (error) => {
        toast.error(error?.message)
      }
    })
  }

  const handlePreUnduhLaporan = (batchId) => {
    setBatchId(batchId)
    handleOpenModalUnduhLampiran()
  }

  const handleRegisterParticipant = (batchId, otherFile, agreementFile, integrityFile) => {
    const formData = new FormData();
    formData.append("training_batch_participant[user_id]", calonMa?.id);
    agreementFile && formData.append("agreement_document", agreementFile);
    integrityFile && formData.append("integrity_document", integrityFile);
    otherFile && formData.append("other_document", otherFile);

    const payload = {
      id: batchId,
      data: formData
    }


    mutateRegisterParticipant(payload, {
      onSuccess: () => {
        handleCloseModalRegisterCalonMa()
        refetchAll()
        toast.success("Berhasil mendaftarkan participant")
      },
      onError: (error) => {
        toast.error(error?.message)
      }
    })
  }

  return (
    <div className='rounded border-[0.5px] border-solid border-[#D8D8D9] mb-4 last:mb-0'>
      <div className='px-4 py-2 '>
        <div className='flex items-center justify-between mb-2'>
          <p className='text-[13px] truncate mr-2'>{name_of_ktp}</p>
          <button onClick={handleOpenModalEditCalonMa} className='cursor-pointer w-[12px] h-[12px] object-contain '>
            <IconInfo />
          </button>
        </div>
        {company?.name ? <p className='text-[11px] text-[#808285]'>{company?.name}</p> : <p className='text-[11px] text-[#808285] line-through'>Belum ada kantor</p>}
        {registration_number && <p className='text-[11px] text-[#D8D8D9]'>No. Registrasi: <span className='font-semibold text-[#252526]'>{registration_number}</span></p>}
      </div>

      {(isFreeBatchOpen || isPaidBatchOpen) && <div className='px-4 py-2 flex justify-end border-t-[0.5px] border-dashed border-[#D8D8D9]'>
        <Button onClick={handleOpenModalRegisterCalonMa} text="Daftarkan Training" />
      </div>}

      <ModalEditCalonMa
        isOpen={isOpenModalEditCalonMa}
        onRequestClose={handleCloseModalEditCalonMa}
        onSuccess={handleOpenModalSuksesEditCalonMa}
        onDelete={handleOpenModalKonfirmasiHapusCalonMa}
        userId={id}
      />
      <ModalSukses
        isOpen={isOpenModalSuksesEditCalonMa}
        onRequestClose={handleCloseModalSuksesEditCalonMa}
        title="Berhasil diubah"
        info="Informasi calon marketing telah diubah."
      />
      <ModalKonfirmasiNegative
        isOpen={isOpenModalKonfirmasiHapusCalonMa}
        onRequestClose={handleCloseModalKonfirmasiHapusCalonMa}
        title="Yakin hapus calon marketing ini?"
        info={`Informasi “${name_of_ktp}” akan dihapus. Perlu mendaftarkan ulang jika ingin memasukkan kembali ke list calon marketing.`}
        onSubmit={handleDeleteCalonMa}
      />
      <ModalDaftarTraining
        isOpen={isOpenModalRegisterCalonMa}
        onRequestClose={handleCloseModalRegisterCalonMa}
        onSubmit={handleRegisterParticipant}
        onUnduhLaporan={handlePreUnduhLaporan}
        list={listAllTrainingAndBatches?.data?.data ?? []}
        isUploadLampiran={isUploadLampiran}
        setUploadLampiran={setUploadLampiran}
      />
      <ModalUnggahLampiran
        isOpen={isModalUnduhLampiran}
        onRequestClose={handleCloseModalUnduhLampiran}
        onSubmit={handleRegisterParticipant}
        onBack={handleOpenModalRegisterCalonMa}
        batchId={batchId}
        isUploadLampiran={isUploadLampiran}
      />
      <ModalSukses
        isOpen={isOpenModalSuksesHapusCalonMa}
        onRequestClose={handleCloseModalSuksesHapusCalonMa}
        title="Calon marketing dihapus"
      />
    </div>
  )
}

export default CardCalonMa